import { render, staticRenderFns } from "./th-tertiary.vue?vue&type=template&id=3f4c0b26&scoped=true"
import script from "./th-tertiary.vue?vue&type=script&lang=js"
export * from "./th-tertiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4c0b26",
  null
  
)

export default component.exports